var r={isRequired:!0,allowEmpty:!1,subscribeOnly:!1,subscribeToLatestOnly:!1,subscribeOnlyForInitialData:!1,alwaysSubscribe:!1,preventWarningsDisplay:!1,preventErrorsDisplay:!1};export{r as DEFAULT_SUBSCRIPTION_META};
